<template>
  <v-card>
    <v-card-title
      class="pr-2"
      :style="{ backgroundColor: companyPrimaryColor }"
    >
      <h2 style="color:white">
        Barometer instellingen {{ activeBranch.branchName }}
      </h2>
      <v-spacer></v-spacer>
      <v-btn icon dark @click="closeBarometerSettingsDialog()">
        <v-icon dark color="white">close</v-icon>
      </v-btn>
    </v-card-title>

    <v-alert class="ma-0 pa-2" v-if="feedback" :value="true" type="warning">{{
      feedback
    }}</v-alert>

    <v-divider></v-divider>

    <v-card-text>
      <v-form ref="barometerSettingsForm" lazy-validation>
        <v-container grid-list-md>
          <v-switch
            class="ma-0 mt-4 pa-0"
            :color="companyPrimaryColor"
            v-model="activeBranch.barometersSettings.useManualGoals"
            label="Financiele doelen zelf invoeren"
          >
          </v-switch>

          <v-card
            outlined
            flat
            v-if="activeBranch.barometersSettings.useManualGoals"
            class="pa-2 text-left "
          >
            <div>
              <v-container grid-list-md>
                <v-layout row wrap class="ma-0 pa-0 mt-1">
                  <v-flex xs4 class="text-left">
                    <v-select
                      style="max-width: 450px;"
                      class="my-2 mb-2"
                      :items="years"
                      :item-color="companyPrimaryColor"
                      background-color="menu"
                      v-on:input="checkManualGoals()"
                      v-model="selectedYear"
                      label="Selecteer jaar"
                      outlined
                      hide-details
                      dense
                    >
                    </v-select>
                  </v-flex>
                  <v-flex
                    xs4
                    class="text-center pt-4"
                    style="font-size: 16px; font-weight: bold;"
                    >Behandelingen</v-flex
                  >
                  <v-flex
                    xs4
                    class="text-center pt-4"
                    style="font-size: 16px; font-weight: bold;"
                    >Producten</v-flex
                  >
                </v-layout>
                <v-layout row wrap class="ma-0 pa-0 mt-2">
                  <v-flex xs4 class="text-left pt-3" style="font-size: 18px;"
                    ><strong>Januari</strong></v-flex
                  >
                  <v-flex xs4 class="text-left">
                    <v-text-field
                      class="ma-0 pa-0"
                      label="Doel bruto omzet behandelingen"
                      type="number"
                      prefix="€"
                      outlined
                      v-model.number="
                        activeBranch.barometersSettings.manualGoalsTreatments[
                          selectedYear
                        ][1]
                      "
                      hide-details
                      dense
                      :color="companyPrimaryColor"
                      background-color="background"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs4 class="text-left">
                    <v-text-field
                      class="ma-0 pa-0"
                      label="Doel bruto omzet producten"
                      type="number"
                      prefix="€"
                      outlined
                      v-model.number="
                        activeBranch.barometersSettings.manualGoalsProducts[
                          selectedYear
                        ][1]
                      "
                      hide-details
                      dense
                      :color="companyPrimaryColor"
                      background-color="background"
                      required
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row wrap class="ma-0 pa-0 mt-2">
                  <v-flex xs4 class="text-left pt-3" style="font-size: 18px;"
                    ><strong>Februari</strong></v-flex
                  >
                  <v-flex xs4 class="text-left">
                    <v-text-field
                      class="ma-0 pa-0"
                      label="Doel bruto omzet behandelingen"
                      type="number"
                      prefix="€"
                      hide-details
                      v-model.number="
                        activeBranch.barometersSettings.manualGoalsTreatments[
                          selectedYear
                        ][2]
                      "
                      outlined
                      dense
                      :color="companyPrimaryColor"
                      background-color="background"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs4 class="text-left">
                    <v-text-field
                      class="ma-0 pa-0"
                      label="Doel bruto omzet producten"
                      type="number"
                      prefix="€"
                      outlined
                      v-model.number="
                        activeBranch.barometersSettings.manualGoalsProducts[
                          selectedYear
                        ][2]
                      "
                      hide-details
                      dense
                      :color="companyPrimaryColor"
                      background-color="background"
                      required
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row wrap class="ma-0 pa-0 mt-2">
                  <v-flex xs4 class="text-left pt-3" style="font-size: 18px;"
                    ><strong>Maart</strong></v-flex
                  >
                  <v-flex xs4 class="text-left">
                    <v-text-field
                      class="ma-0 pa-0"
                      label="Doel bruto omzet behandelingen"
                      type="number"
                      prefix="€"
                      hide-details
                      v-model.number="
                        activeBranch.barometersSettings.manualGoalsTreatments[
                          selectedYear
                        ][3]
                      "
                      outlined
                      dense
                      :color="companyPrimaryColor"
                      background-color="background"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs4 class="text-left">
                    <v-text-field
                      class="ma-0 pa-0"
                      label="Doel bruto omzet producten"
                      type="number"
                      prefix="€"
                      outlined
                      v-model.number="
                        activeBranch.barometersSettings.manualGoalsProducts[
                          selectedYear
                        ][3]
                      "
                      hide-details
                      dense
                      :color="companyPrimaryColor"
                      background-color="background"
                      required
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row wrap class="ma-0 pa-0 mt-2">
                  <v-flex xs4 class="text-left pt-3" style="font-size: 18px;"
                    ><strong>April</strong></v-flex
                  >
                  <v-flex xs4 class="text-left">
                    <v-text-field
                      class="ma-0 pa-0"
                      label="Doel bruto omzet behandelingen"
                      type="number"
                      prefix="€"
                      outlined
                      v-model.number="
                        activeBranch.barometersSettings.manualGoalsTreatments[
                          selectedYear
                        ][4]
                      "
                      hide-details
                      dense
                      :color="companyPrimaryColor"
                      background-color="background"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs4 class="text-left">
                    <v-text-field
                      class="ma-0 pa-0"
                      label="Doel bruto omzet producten"
                      type="number"
                      prefix="€"
                      outlined
                      v-model.number="
                        activeBranch.barometersSettings.manualGoalsProducts[
                          selectedYear
                        ][4]
                      "
                      hide-details
                      dense
                      :color="companyPrimaryColor"
                      background-color="background"
                      required
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row wrap class="ma-0 pa-0 mt-2">
                  <v-flex xs4 class="text-left pt-3" style="font-size: 18px;"
                    ><strong>Mei</strong></v-flex
                  >
                  <v-flex xs4 class="text-left">
                    <v-text-field
                      class="ma-0 pa-0"
                      label="Doel bruto omzet behandelingen"
                      type="number"
                      prefix="€"
                      hide-details
                      v-model.number="
                        activeBranch.barometersSettings.manualGoalsTreatments[
                          selectedYear
                        ][5]
                      "
                      outlined
                      dense
                      :color="companyPrimaryColor"
                      background-color="background"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs4 class="text-left">
                    <v-text-field
                      class="ma-0 pa-0"
                      label="Doel bruto omzet producten"
                      type="number"
                      prefix="€"
                      outlined
                      v-model.number="
                        activeBranch.barometersSettings.manualGoalsProducts[
                          selectedYear
                        ][5]
                      "
                      hide-details
                      dense
                      :color="companyPrimaryColor"
                      background-color="background"
                      required
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row wrap class="ma-0 pa-0 mt-2">
                  <v-flex xs4 class="text-left pt-3" style="font-size: 18px;"
                    ><strong>Juni</strong></v-flex
                  >
                  <v-flex xs4 class="text-left">
                    <v-text-field
                      class="ma-0 pa-0"
                      label="Doel bruto omzet behandelingen"
                      type="number"
                      prefix="€"
                      hide-details
                      v-model.number="
                        activeBranch.barometersSettings.manualGoalsTreatments[
                          selectedYear
                        ][6]
                      "
                      outlined
                      dense
                      :color="companyPrimaryColor"
                      background-color="background"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs4 class="text-left">
                    <v-text-field
                      class="ma-0 pa-0"
                      label="Doel bruto omzet producten"
                      type="number"
                      prefix="€"
                      outlined
                      v-model.number="
                        activeBranch.barometersSettings.manualGoalsProducts[
                          selectedYear
                        ][6]
                      "
                      hide-details
                      dense
                      :color="companyPrimaryColor"
                      background-color="background"
                      required
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row wrap class="ma-0 pa-0 mt-2">
                  <v-flex xs4 class="text-left pt-3" style="font-size: 18px;"
                    ><strong>Juli</strong></v-flex
                  >
                  <v-flex xs4 class="text-left">
                    <v-text-field
                      class="ma-0 pa-0"
                      label="Doel bruto omzet behandelingen"
                      type="number"
                      prefix="€"
                      outlined
                      v-model.number="
                        activeBranch.barometersSettings.manualGoalsTreatments[
                          selectedYear
                        ][7]
                      "
                      hide-details
                      dense
                      :color="companyPrimaryColor"
                      background-color="background"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs4 class="text-left">
                    <v-text-field
                      class="ma-0 pa-0"
                      label="Doel bruto omzet producten"
                      type="number"
                      prefix="€"
                      outlined
                      v-model.number="
                        activeBranch.barometersSettings.manualGoalsProducts[
                          selectedYear
                        ][7]
                      "
                      hide-details
                      dense
                      :color="companyPrimaryColor"
                      background-color="background"
                      required
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row wrap class="ma-0 pa-0 mt-2">
                  <v-flex xs4 class="text-left pt-3" style="font-size: 18px;"
                    ><strong>Augustus</strong></v-flex
                  >
                  <v-flex xs4 class="text-left">
                    <v-text-field
                      class="ma-0 pa-0"
                      label="Doel bruto omzet behandelingen"
                      type="number"
                      prefix="€"
                      hide-details
                      v-model.number="
                        activeBranch.barometersSettings.manualGoalsTreatments[
                          selectedYear
                        ][8]
                      "
                      outlined
                      dense
                      :color="companyPrimaryColor"
                      background-color="background"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs4 class="text-left">
                    <v-text-field
                      class="ma-0 pa-0"
                      label="Doel bruto omzet producten"
                      type="number"
                      prefix="€"
                      outlined
                      v-model.number="
                        activeBranch.barometersSettings.manualGoalsProducts[
                          selectedYear
                        ][8]
                      "
                      hide-details
                      dense
                      :color="companyPrimaryColor"
                      background-color="background"
                      required
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row wrap class="ma-0 pa-0 mt-2">
                  <v-flex xs4 class="text-left pt-3" style="font-size: 18px;"
                    ><strong>September</strong></v-flex
                  >
                  <v-flex xs4 class="text-left">
                    <v-text-field
                      class="ma-0 pa-0"
                      label="Doel bruto omzet behandelingen"
                      type="number"
                      prefix="€"
                      hide-details
                      v-model.number="
                        activeBranch.barometersSettings.manualGoalsTreatments[
                          selectedYear
                        ][9]
                      "
                      outlined
                      dense
                      :color="companyPrimaryColor"
                      background-color="background"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs4 class="text-left">
                    <v-text-field
                      class="ma-0 pa-0"
                      label="Doel bruto omzet producten"
                      type="number"
                      prefix="€"
                      outlined
                      v-model.number="
                        activeBranch.barometersSettings.manualGoalsProducts[
                          selectedYear
                        ][9]
                      "
                      hide-details
                      dense
                      :color="companyPrimaryColor"
                      background-color="background"
                      required
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row wrap class="ma-0 pa-0 mt-2">
                  <v-flex xs4 class="text-left pt-3" style="font-size: 18px;"
                    ><strong>Oktober</strong></v-flex
                  >
                  <v-flex xs4 class="text-left">
                    <v-text-field
                      class="ma-0 pa-0"
                      label="Doel bruto omzet behandelingen"
                      type="number"
                      prefix="€"
                      outlined
                      v-model.number="
                        activeBranch.barometersSettings.manualGoalsTreatments[
                          selectedYear
                        ][10]
                      "
                      hide-details
                      dense
                      :color="companyPrimaryColor"
                      background-color="background"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs4 class="text-left">
                    <v-text-field
                      class="ma-0 pa-0"
                      label="Doel bruto omzet producten"
                      type="number"
                      prefix="€"
                      outlined
                      v-model.number="
                        activeBranch.barometersSettings.manualGoalsProducts[
                          selectedYear
                        ][10]
                      "
                      hide-details
                      dense
                      :color="companyPrimaryColor"
                      background-color="background"
                      required
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row wrap class="ma-0 pa-0 mt-2">
                  <v-flex xs4 class="text-left pt-3" style="font-size: 18px;"
                    ><strong>November</strong></v-flex
                  >
                  <v-flex xs4 class="text-left">
                    <v-text-field
                      class="ma-0 pa-0"
                      label="Doel bruto omzet behandelingen"
                      type="number"
                      prefix="€"
                      hide-details
                      v-model.number="
                        activeBranch.barometersSettings.manualGoalsTreatments[
                          selectedYear
                        ][11]
                      "
                      outlined
                      dense
                      :color="companyPrimaryColor"
                      background-color="background"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs4 class="text-left">
                    <v-text-field
                      class="ma-0 pa-0"
                      label="Doel bruto omzet producten"
                      type="number"
                      prefix="€"
                      outlined
                      v-model.number="
                        activeBranch.barometersSettings.manualGoalsProducts[
                          selectedYear
                        ][11]
                      "
                      hide-details
                      dense
                      :color="companyPrimaryColor"
                      background-color="background"
                      required
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row wrap class="ma-0 pa-0 mt-2">
                  <v-flex xs4 class="text-left pt-3" style="font-size: 18px;"
                    ><strong>December</strong></v-flex
                  >
                  <v-flex xs4 class="text-left">
                    <v-text-field
                      class="ma-0 pa-0"
                      label="Doel bruto omzet behandelingen"
                      type="number"
                      prefix="€"
                      hide-details
                      v-model.number="
                        activeBranch.barometersSettings.manualGoalsTreatments[
                          selectedYear
                        ][12]
                      "
                      outlined
                      dense
                      :color="companyPrimaryColor"
                      background-color="background"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex md4 class="text-left">
                    <v-text-field
                      class="ma-0 pa-0"
                      label="Doel bruto omzet producten"
                      type="number"
                      prefix="€"
                      outlined
                      v-model.number="
                        activeBranch.barometersSettings.manualGoalsProducts[
                          selectedYear
                        ][12]
                      "
                      hide-details
                      dense
                      :color="companyPrimaryColor"
                      background-color="background"
                      required
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </div>
          </v-card>

          <v-card
            outlined
            flat
            v-if="!activeBranch.barometersSettings.useManualGoals"
            class="pa-4"
          >
            <v-alert
              icon="mdi-cash-multiple"
              prominent
              text
              dense
              colored-border
              border="left"
              type="info"
            >
              Financiel doelstellingen worden berekend op basis van de behaalde
              resultaten in dezelfde periode vorige jaar.
            </v-alert>

            <div
              class="barometer-item-setting-wrapper"
              v-if="
                activeCompData.barometersSettings.showWeekGoalProductsBarometer
              "
            >
              <h2>Doelstelling producten</h2>

              <!-- Weergeven als productverkoop niet gekoppeld is aan de omzet -->
              <div
                v-if="
                  !activeCompData.barometersSettings
                    .useRevenuePercentageForProducts
                "
              >
                <v-switch
                  :color="companyPrimaryColor"
                  v-model="
                    activeBranch.barometersSettings.ProductManipulateActive
                  "
                  v-on:click.native="checkManupulateNumbers()"
                  hide-details
                >
                  <template slot="label">
                    <span style="color: #333; margin-right: 5px;"
                      >Weergave doel producten manipuleren</span
                    >
                    <v-tooltip class="ma-0 pa-0" bottom>
                      <template v-slot:activator="{ on }">
                        <v-icon color="#ccc" v-on="on">help</v-icon>
                      </template>
                      <span style="color: #fff;"
                        >Het daadwerkelijke doel en het doel dat wordt
                        weergegeven bij de barometer kan verschillend zijn met
                        manipulatie.</span
                      >
                    </v-tooltip>
                  </template>
                </v-switch>

                <v-layout row wrap>
                  <v-flex xs6>
                    <v-text-field
                      class="mt-4"
                      label="Doel productverkoop"
                      v-model.number="
                        activeBranch.barometersSettings.ProductSaleTarget
                      "
                      type="number"
                      outlined
                      dense
                      :color="companyPrimaryColor"
                      background-color="background"
                      hint="Met dit percentage wordt het weekdoel berekend."
                      persistent-hint
                      suffix="%"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6>
                    <v-text-field
                      class="mt-4"
                      v-if="
                        activeBranch.barometersSettings
                          .ProductManipulateActive == true
                      "
                      label="Weergave doel productverkoop"
                      v-model.number="
                        activeBranch.barometersSettings.ProductManipulate
                      "
                      type="number"
                      outlined
                      :color="companyPrimaryColor"
                      background-color="background"
                      hint="Dit is het percentage dat wordt weergegeven."
                      persistent-hint
                      suffix="%"
                      required
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </div>
            </div>
            <div class="barometer-item-setting-wrapper">
              <h2>Doelstelling Behandelingen</h2>

              <v-switch
                class="ma-0 mt-4 pa-0"
                :color="companyPrimaryColor"
                v-model="
                  activeBranch.barometersSettings.TreatmentManipulateActive
                "
              >
                <template slot="label">
                  <span style="color: #333; margin-right: 5px;"
                    >Weergave doel behandelingen manipuleren</span
                  >
                  <v-tooltip class="ma-0 pa-0" bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon color="#ccc" v-on="on">help</v-icon>
                    </template>
                    <span style="color: #fff;"
                      >Het daadwerkelijke doel en het doel dat wordt weergegeven
                      bij de barometer kan verschillend zijn met
                      manipulatie.</span
                    >
                  </v-tooltip>
                </template>
              </v-switch>

              <v-layout row wrap>
                <v-flex xs6>
                  <v-text-field
                    label="Doel behandelingen"
                    v-model.number="
                      activeBranch.barometersSettings.TreatmentSaleTarget
                    "
                    type="number"
                    hint="Met dit percentage wordt het weekdoel berekend."
                    persistent-hint
                    suffix="%"
                    dense
                    outlined
                    :color="companyPrimaryColor"
                    background-color="background"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    v-if="
                      activeBranch.barometersSettings
                        .TreatmentManipulateActive == true
                    "
                    label="Weergave doel behandeelingen"
                    v-model.number="
                      activeBranch.barometersSettings.TreatmentManipulate
                    "
                    type="number"
                    hint="Dit is het percentage dat wordt weergegeven."
                    persistent-hint
                    outlined
                    dense
                    :color="companyPrimaryColor"
                    background-color="background"
                    suffix="%"
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </div>
            <div class="barometer-item-setting-wrapper">
              <h2>Doelstelling 4 weken</h2>
              <v-switch
                class="ma-0 mt-4 pa-0"
                :color="companyPrimaryColor"
                v-model="
                  activeBranch.barometersSettings
                    .Total4WeeksSaleManipulateActive
                "
              >
                <template slot="label">
                  <span style="color: #333; margin-right: 5px;"
                    >Weergave doel behandelingen manipuleren</span
                  >
                  <v-tooltip class="ma-0 pa-0" bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon color="#ccc" v-on="on">help</v-icon>
                    </template>
                    <span style="color: #fff;"
                      >Het daadwerkelijke doel en het doel dat wordt weergegeven
                      bij de barometer kan verschillend zijn met
                      manipulatie.</span
                    >
                  </v-tooltip>
                </template>
              </v-switch>
              <v-layout row wrap>
                <v-flex xs6>
                  <v-text-field
                    label="Doel per 4 weken"
                    v-model.number="
                      activeBranch.barometersSettings.Total4WeeksSaleTarget
                    "
                    type="number"
                    outlined
                    :color="companyPrimaryColor"
                    background-color="background"
                    hint="Met dit percentage wordt het weekdoel berekend."
                    persistent-hint
                    dense
                    suffix="%"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    v-if="
                      activeBranch.barometersSettings
                        .Total4WeeksSaleManipulateActive == true
                    "
                    label="Weergave doel per 4 weken"
                    v-model.number="
                      activeBranch.barometersSettings.Total4WeeksSaleManipulate
                    "
                    type="number"
                    outlined
                    :color="companyPrimaryColor"
                    background-color="background"
                    hint="Dit is het percentage dat wordt weergegeven."
                    persistent-hint
                    dense
                    suffix="%"
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </div>
          </v-card>

          <v-card outlined flat class="mt-4 pa-4 text-left">
            <v-card-title class="pa-0">Algemene instellingen</v-card-title>
            <!-- Weergeven als productverkoop niet gekoppeld is aan de omzet -->
            <div
              v-if="
                activeCompData.barometersSettings
                  .useRevenuePercentageForProducts
              "
            >
              <v-layout row wrap>
                <v-flex xs6>
                  <v-text-field
                    outlined
                    class="mt-4"
                    :color="companyPrimaryColor"
                    background-color="background"
                    label="Doel productverkoop"
                    dense
                    v-model.number="
                      activeBranch.barometersSettings.ProductSaleRevenueTarget
                    "
                    type="number"
                    hint="Met dit percentage wordt het weekdoel berekend."
                    persistent-hint
                    suffix="% van de totale omzet"
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </div>

            <div class="barometer-item-setting-wrapper pb-0 mb-0 mt-3">
              <v-layout row wrap>
                <v-flex xs6>
                  <h2>Doelstelling Kleuringen</h2>
                  <v-text-field
                    class="mt-4"
                    label="Aantal kleuringen"
                    v-model.number="
                      activeBranch.barometersSettings.ColourSaleTarget
                    "
                    type="number"
                    hint="Doel aantal kleuringen deze week."
                    persistent-hint
                    outlined
                    dense
                    :color="companyPrimaryColor"
                    background-color="background"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <h2>Besteding per klant</h2>
                  <v-text-field
                    class="mt-4"
                    label="Gemiddelde besteding per klant"
                    v-model.number="
                      activeBranch.barometersSettings.revenuePerTicket
                    "
                    type="number"
                    outlined
                    :color="companyPrimaryColor"
                    background-color="background"
                    prefix="€"
                    hint="Gemiddelde besteding per klant bij een afspraak."
                    persistent-hint
                    dense
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout
                row
                wrap
                v-if="activeCompData.barometersSettings.dyflexis"
              >
                <v-flex xs6>
                  <h2>Dyfexis instellingen</h2>
                  <v-text-field
                    class="mt-4"
                    label="Dyfexis Office ID"
                    v-model.number="
                      activeBranch.barometersSettings.dyflexisBranchId
                    "
                    type="number"
                    outlined
                    dense
                    :color="companyPrimaryColor"
                    background-color="background"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs6></v-flex>
              </v-layout>
            </div>
          </v-card>
        </v-container>
      </v-form>
    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions>
      <v-container grid-list-md fluid class="ma-0 pa-0">
        <v-layout row wrap class="ma-0 pa-0">
          <v-flex
            xs12
            md6
            class="text-left"
            v-if="
              $vuetify.breakpoint.name != 'sm' &&
                $vuetify.breakpoint.name != 'xs'
            "
          >
            <v-btn
              outlined
              depressed
              color="#8B93A6"
              @click="closeBarometerSettingsDialog()"
            >
              Annuleren
            </v-btn>
          </v-flex>
          <v-flex xs12 md6 class="text-right">
            <v-btn
              :disabled="!changed"
              :depressed="!changed"
              :dark="changed"
              :block="
                $vuetify.breakpoint.name == 'sm' ||
                  $vuetify.breakpoint.name == 'xs'
              "
              rounded
              :color="companySecondaryColor"
              @click="saveSettings()"
            >
              Wijzigingen opslaan
              <v-icon right dark>chevron_right</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-actions>
  </v-card>
</template>

<script>
import db from "../../firebase/init";
import firebase from "firebase/compat/app";
import lodash from "lodash";
import platform from "platform";
import moment from "moment";

export default {
  name: "edit-barometer-settings-form",
  props: {
    activeBranchOriginal: Object,
    activeBranch: Object,
    activeCompData: Object,
  },
  data() {
    return {
      feedback: null,
      selectedYear: null,
      years: [],
      errors: [],
    };
  },
  created() {
    this.checkManualGoals("first");
  },

  methods: {
    checkManupulateNumbers() {
      if (
        this.activeBranch.barometersSettings.ProductManipulateActive == false
      ) {
        this.activeBranch.barometersSettings.ProductManipulate = this.activeBranch.barometersSettings.ProductSaleTarget;
      }
      if (
        this.activeBranch.barometersSettings.TreatmentManipulateActive == false
      ) {
        this.activeBranch.barometersSettings.TreatmentManipulate = this.activeBranch.barometersSettings.TreatmentSaleTarget;
      }
      if (
        this.activeBranch.barometersSettings.Total4WeeksSaleManipulateActive ==
        false
      ) {
        this.activeBranch.barometersSettings.Total4WeeksSaleManipulate = this.activeBranch.barometersSettings.Total4WeeksSaleTarget;
      }
    },
    closeBarometerSettingsDialog() {
      this.$emit("editBarometerSettingsDialogChange", false);
      this.feedback = null;
    },

    checkManualGoals(type) {
      let currentYear = moment().format("YYYY");
      if (type == "first") {
        this.selectedYear = Number(currentYear);
        this.years.push(this.selectedYear);
        this.years.push(this.selectedYear + 1);
      }
      if (!this.activeBranch.barometersSettings.manualGoalsTreatments) {
        this.activeBranch.barometersSettings.manualGoalsTreatments = new Object();
      }
      if (
        !this.activeBranch.barometersSettings.manualGoalsTreatments[
          this.selectedYear
        ]
      ) {
        this.activeBranch.barometersSettings.manualGoalsTreatments[
          this.selectedYear
        ] = new Object();
      }
      if (!this.activeBranch.barometersSettings.manualGoalsProducts) {
        this.activeBranch.barometersSettings.manualGoalsProducts = new Object();
      }
      if (
        !this.activeBranch.barometersSettings.manualGoalsProducts[
          this.selectedYear
        ]
      ) {
        this.activeBranch.barometersSettings.manualGoalsProducts[
          this.selectedYear
        ] = new Object();
      }
    },

    saveSettings() {
      let barometersSettings = this.activeBranch.barometersSettings;

      db.collection("branches")
        .doc(this.activeBranch.id)
        .update({ barometersSettings })
        .then(() => {
          db.collection("log")
            .add({
              time: new Date(),
              logType: "info",
              user: this.userFirstName + " " + this.userLastName,
              userType: this.userRole,
              company: this.userCompany,
              actionType: "User Action",
              software: String(platform.os),
              browser: platform.name + " " + platform.version,
              pillarrrVersion: this.$store.state.version,
              action:
                "Barometer instellingen gewijzigd: " +
                this.activeCompData.name +
                " " +
                this.activeBranch.branchName,
              extra:
                "<b>ORIGINELE GEGEVENS</b> " +
                "<br>" +
                "<b>Kleurdoelstelling (Aantal):</b> " +
                this.activeBranchOriginal.barometersSettings.ColourSaleTarget +
                "<br><br>" +
                "<b>Product target t.o.v. vorig jaar in %:</b> " +
                this.activeBranchOriginal.barometersSettings.ProductSaleTarget +
                "<br>" +
                "<b>Product manipulatie actief:</b> " +
                this.activeBranchOriginal.barometersSettings
                  .ProductManipulateActive +
                "<br>" +
                "<b>Product manipulatie weergave doel in %:</b> " +
                this.activeBranchOriginal.barometersSettings.ProductManipulate +
                "<br><br>" +
                "<b>Doelstelling 4 weken t.o.v. vorig jaar in %:</b> " +
                this.activeBranchOriginal.barometersSettings
                  .Total4WeeksSaleTarget +
                "<br>" +
                "<b>Doelstelling 4 weken manipulatie actief:</b> " +
                this.activeBranchOriginal.barometersSettings
                  .Total4WeeksSaleManipulateActive +
                "<br>" +
                "<b>Doelstelling 4 weken manipulatie weergave doel in %:</b> " +
                this.activeBranchOriginal.barometersSettings
                  .Total4WeeksSaleManipulate +
                "<br><br>" +
                "<b>Doelstelling behandelingen t.o.v. vorig jaar in %:</b> " +
                this.activeBranchOriginal.barometersSettings
                  .TreatmentSaleTarget +
                "<br>" +
                "<b>Doelstelling behandelingen manipulatie actief:</b> " +
                this.activeBranchOriginal.barometersSettings
                  .TreatmentManipulateActive +
                "<br>" +
                "<b>Doelstelling behandelingen manipulatie weergave doel in %:</b> " +
                this.activeBranchOriginal.barometersSettings
                  .TreatmentManipulate +
                "<br><br><br>" +
                "<b>AANGEPAST GEGEVENS</b> " +
                "<br>" +
                "<b>Kleurdoelstelling (Aantal):</b> " +
                this.activeBranch.barometersSettings.ColourSaleTarget +
                "<br><br>" +
                "<b>Product target t.o.v. vorig jaar in %:</b> " +
                this.activeBranch.barometersSettings.ProductSaleTarget +
                "<br>" +
                "<b>Product manipulatie actief:</b> " +
                this.activeBranch.barometersSettings.ProductManipulateActive +
                "<br>" +
                "<b>Product manipulatie weergave doel in %:</b> " +
                this.activeBranch.barometersSettings.ProductManipulate +
                "<br><br>" +
                "<b>Doelstelling 4 weken t.o.v. vorig jaar in %:</b> " +
                this.activeBranch.barometersSettings.Total4WeeksSaleTarget +
                "<br>" +
                "<b>Doelstelling 4 weken manipulatie actief:</b> " +
                this.activeBranch.barometersSettings
                  .Total4WeeksSaleManipulateActive +
                "<br>" +
                "<b>Doelstelling 4 weken manipulatie weergave doel in %:</b> " +
                this.activeBranch.barometersSettings.Total4WeeksSaleManipulate +
                "<br><br>" +
                "<b>Doelstelling behandelingen t.o.v. vorig jaar in %:</b> " +
                this.activeBranch.barometersSettings.TreatmentSaleTarget +
                "<br>" +
                "<b>Doelstelling behandelingen manipulatie actief:</b> " +
                this.activeBranch.barometersSettings.TreatmentManipulateActive +
                "<br>" +
                "<b>Doelstelling behandelingen manipulatie weergave doel in %:</b> " +
                this.activeBranch.barometersSettings.TreatmentManipulate,
            })
            .catch((error) => {
              console.error("Error logging barometer settings: ", error);
            });
        })
        .then(() => {
          this.$emit("updateData");
          this.closeBarometerSettingsDialog();
        })
        .catch((error) => {
          console.error("Error updating Barometer Settings: ", error);
          db.collection("log").add({
            time: new Date(),
            logType: "error",
            user: this.userFirstName + " " + this.userLastName,
            userType: this.userRole,
            company: this.userCompany,
            software: String(platform.os),
            browser: platform.name + " " + platform.version,
            pillarrrVersion: this.$store.state.version,
            actionType: "User Action",
            action:
              "Error updating Barometer Settings: " +
              this.activeCompData.name +
              " " +
              this.activeBranch.branchName,
            extra: JSON.stringify(error),
          });
        });
    },
  },

  computed: {
    userCompanies() {
      return this.$store.state.userCompanies;
    },
    userCompany() {
      return this.$store.state.userCompany;
    },
    userFirstName() {
      return this.$store.state.userFirstName;
    },
    userLastName() {
      return this.$store.state.userLastName;
    },
    userRole() {
      return this.$store.state.userRole;
    },
    companyPrimaryColor() {
      return this.$store.state.companyPrimaryColor;
    },
    companySecondaryColor() {
      return this.$store.state.companySecondaryColor;
    },
    changed() {
      if (
        _.isEqual(
          this.activeBranch.barometersSettings,
          this.activeBranchOriginal.barometersSettings,
        ) == false
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>
